export enum AlertSeverityLevel {
    Watch = 1,
    Action = 2,
    Alert = 3,
    Critical = 4,
}

export const UNKNOWN_ALERT_SEVERITY = -1;

export enum AlertEventState {
    Active = 1,
    Resolved = 2,
    Acknowledged = 3,
    Escalated = 4
}

export enum AlertDeliveryStatus {
    Pending = 0,
    Sent = 1,
    Delivered = 2,
    Failed = 3,
    Opened = 4,
}

export enum AlertDeliveryChannel {
    Email = 0,
    SMS = 1,
    InApp = 2,
    Push = 3,
}

export enum AlertEventTransitionSource {
    InAppUi = 0,
    ApiCall = 1,
    EmailLink = 2,
    SmsDeepLink = 3,
    AutoEscalation = 4,
    AutoResolve = 5,
}

export function alertSeverityLabel(severity: AlertSeverityLevel | number | null | undefined): string {
    switch (severity) {
        case AlertSeverityLevel.Critical:
            return 'Critical';
        case AlertSeverityLevel.Alert:
            return 'Alert';
        case AlertSeverityLevel.Action:
            return 'Action';
        case AlertSeverityLevel.Watch:
            return 'Watch';
        default:
            return 'Unknown';
    }
}

const SENT_DELIVERY_STATUSES: ReadonlySet<AlertDeliveryStatus> = new Set([
    AlertDeliveryStatus.Sent,
    AlertDeliveryStatus.Delivered,
    AlertDeliveryStatus.Opened,
]);

// Pending rows were never dispatched and Failed rows never reached the recipient, so neither
// counts as a notification having been sent.
export function isAlertDeliverySent(status: AlertDeliveryStatus | string | number | null | undefined): boolean {
    return typeof status === 'number' && SENT_DELIVERY_STATUSES.has(status);
}

export function alertDeliveryChannelLabel(channel: AlertDeliveryChannel | string | number | null | undefined): string {
    switch (channel) {
        case AlertDeliveryChannel.Email:
            return 'Email';
        case AlertDeliveryChannel.SMS:
            return 'SMS';
        case AlertDeliveryChannel.InApp:
            return 'In App';
        case AlertDeliveryChannel.Push:
            return 'Push';
        default:
            return typeof channel === 'string' ? channel : '';
    }
}
